declare var Cypress: any;

export enum JOB_TYPES {
  ONSITE_JOB = 'O',
  HARDWARE_JOB = 'S',
  REMOTE_JOB = 'R',
}

export const environment = {
  production: true,
  env: 'production',
  geeks2u_api_version: 1,
  geeks2u_app_version: '1.16.9.656',
  geeks2u_api_url: 'https://api.geeks2u.net.au/api/',
  recpatcha_key: '6Ldp0sEbAAAAAIwTqh2D81usXa8x1WyPJwt6La4g',
  geeks2u_reschedule_form:
    'https://geeks2u.wufoo.com/forms/geeks2u-reschedule-request-form/',
  geeks2u_warranty_form:
    'https://geeks2u.wufoo.com/forms/geeks2u-warranty-form/',
  geeks2u_assistance_form:
    'https://geeks2u.wufoo.com/forms/geeks2u-assistance-request-form/',
  geeks2u_insurance_report_form:
    'https://geeks2u.wufoo.com/forms/insurance-report-builder',
  geeks2u_invoice_adjust_form:
    'https://geeks2u.wufoo.com/forms/geeks2u-technician-invoice-adjustment-requests/',
  geeks2u_hide_technician_same_day_confirmation_toggle: true,
  auth0_audience: 'https://app.geeks2u.net.au/',
  auth0_clientId: 'zAMPyHSEqj1ehRcAvlxDtfPPMqe4m7uI',
  auth0_domain: 'auth.geeks2u.net.au',
  auth0_logout_uri: 'https://app.geeks2u.net.au/logout',
  auth0_redirect_uri: 'https://app.geeks2u.net.au/home',
  cypress: typeof Cypress !== 'undefined',
  wp_file_url: '__WP_FILE_URL__',
  datadog_enable: true,
  datadog_application_id: '3917ab8e-ac52-4c3c-b0ae-62de673fabfc',
  datadog_client_token: 'pubd93d69b456a8c25bf15794268ded765f',
  datadog_env: 'prod',
  knowledge_ref: '/knowledge/12',
};
